import { projectStatusByCode, isLeader } from 'entities';

import { FolderSyncIcon } from 'components/Icons';

import { registerProjectOption } from '../options';

import { TeamChangeModal } from './TeamChangeModal';

export default registerProjectOption({
  Icon: FolderSyncIcon,

  getLabel: (t) => t('team-change'),

  modal: 'CHANGE_TEAM',
  overlay: TeamChangeModal,

  shortcut: {
    key: 'J',
    triggerKey: ['ctrl'],
  },

  useOption: ({ loggedUser, project, openModal }) => {
    const canChangeTeam = [
      projectStatusByCode[project.status].canChangeTeam,
      isLeader(loggedUser),
      loggedUser.team.canCreateProject || loggedUser.team.canAssumeProject,
    ].every(Boolean);

    return {
      action: () => openModal('CHANGE_TEAM'),
      isEnabled: canChangeTeam,
    };
  },
});
